// extracted by mini-css-extract-plugin
export default {"wrap":"tq-z","logoContainer":"uq-z","brandImg":"vq-z","logoImg":"wq-z","logoButton":"xq-z"};